import { FileText, Trash2 } from 'lucide-react'

type UploadedFileRowProps = {
  fileName: string
  label?: string
  onView?: () => void
  onReplace?: () => void
  onRemove?: () => void
  disabled?: boolean
}

export function UploadedFileRow({
  fileName,
  label,
  onView,
  onReplace,
  onRemove,
  disabled = false
}: UploadedFileRowProps) {
  return (
    <div className='flex flex-col gap-2 rounded-xl border border-accent bg-accent-light/30 px-4 py-3 sm:flex-row sm:items-center sm:gap-3'>
      {label && (
        <span className='shrink-0 text-[11px] font-medium tracking-wide text-ink-muted uppercase sm:min-w-[10rem]'>
          {label}
        </span>
      )}
      <div className='flex min-w-0 items-center gap-3'>
        <FileText className='size-5 shrink-0 text-accent dark:text-accent-mid' />
        {onView ? (
          <button
            type='button'
            onClick={onView}
            className='min-w-0 flex-1 truncate text-left text-[13px] font-medium text-ink underline-offset-2 hover:text-accent hover:underline dark:hover:text-accent-mid'
          >
            {fileName}
          </button>
        ) : (
          <p className='min-w-0 flex-1 truncate text-[13px] font-medium text-ink'>
            {fileName}
          </p>
        )}
      </div>
      {onReplace && (
        <button
          type='button'
          onClick={onReplace}
          disabled={disabled}
          className='min-h-11 shrink-0 rounded-md px-2 text-[12px] font-medium text-ink-muted transition-colors hover:bg-page hover:text-ink disabled:opacity-50 sm:ml-auto sm:min-h-0 sm:py-1'
        >
          Replace
        </button>
      )}
      {onRemove && (
        <button
          type='button'
          onClick={onRemove}
          disabled={disabled}
          aria-label={label ? `Remove ${label}` : `Remove ${fileName}`}
          className='grid size-11 shrink-0 cursor-pointer place-items-center self-end rounded-md text-ink-muted transition-colors hover:bg-red-50 hover:text-red-700 disabled:opacity-50 sm:size-8 sm:self-auto dark:hover:bg-red-950/40 dark:hover:text-red-300'
        >
          <Trash2 className='size-3.5' />
        </button>
      )}
    </div>
  )
}
